module.exports = __webpack_public_path__ + "img/empty_edit.8f70da90.png";